export enum UrlSegment {
  SIGN_IN = 'sign-in',
  FORGOT_PASSWORD = 'forgot-password',
  RESET_PASSWORD = 'reset-password',
  ACTIVATION = 'activation',
  HOME = 'home',
  COMPANIES = 'companies',
  REPORTS = 'reports',
  FILES = 'files',
  SECURITY = 'security',
  USER_PROFILE = 'user-profile',
  SIGN_OUT = 'sign-out',
  INDUSTRIES = 'industries',
  USERS = 'users',
  GROUPS = 'groups',
  COOPERATIONS = 'cooperations',
  PROJECTS = 'projects',
  OSH = 'osh',
  PROJECTS_LIST = 'projects-list',
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  DRAFTS = 'drafts',
  DRAFT_PROJECTS = 'draft-projects',
  CREATE = 'create',
  LOCATIONS = 'locations',
  PARTICIPANTS = 'participants',
  TASKS = 'tasks',
  EDIT = 'edit',
  TAGS = 'tags',
  WORK_TIME = 'work-time'
}
